import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { contactInfo, stores } from '../mock';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-[#0f2c1f] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="KST Spice Corner" className="w-14 h-14 rounded-full object-cover ring-2 ring-[#c8a24c]/60" />
              <div className="font-serif-display text-lg font-bold leading-tight">
                KST Spice<br />Corner
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Sydney's premier destination for authentic Indian & Sri Lankan groceries since 2011.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#c8a24c] hover:text-[#0f2c1f] hover:border-[#c8a24c] transition-colors duration-300">
                <Instagram size={16} />
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#c8a24c] hover:text-[#0f2c1f] hover:border-[#c8a24c] transition-colors duration-300">
                <Facebook size={16} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif-display text-lg mb-4 text-[#c8a24c]">Explore</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/" className="hover:text-[#c8a24c] transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#c8a24c] transition-colors">About Us</Link></li>
              <li><Link to="/brands" className="hover:text-[#c8a24c] transition-colors">Sinthia & KST Brands</Link></li>
              <li><Link to="/stores" className="hover:text-[#c8a24c] transition-colors">Our Stores</Link></li>
              <li><Link to="/contact" className="hover:text-[#c8a24c] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Stores */}
          <div>
            <h4 className="font-serif-display text-lg mb-4 text-[#c8a24c]">Our Stores</h4>
            <ul className="space-y-4 text-sm text-white/70">
              {stores.map((s) => (
                <li key={s.id} className="flex gap-2">
                  <MapPin size={16} className="text-[#c8a24c] shrink-0 mt-0.5" />
                  <div>
                    <div className="text-white/90 font-medium">{s.name}</div>
                    <div className="text-white/55">{s.address}</div>
                    <div className="flex items-center gap-1.5 mt-1 text-white/70">
                      <Phone size={13} className="text-[#c8a24c]" />
                      <a href={`tel:${s.phone.replace(/[^0-9+]/g, '')}`} className="hover:text-[#c8a24c] transition-colors">{s.phone}</a>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif-display text-lg mb-4 text-[#c8a24c]">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex gap-2 items-center">
                <Mail size={16} className="text-[#c8a24c]" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-[#c8a24c] transition-colors break-all">{contactInfo.email}</a>
              </li>
              <li className="text-white/55">
                Mon–Sun: 8:00 AM – 9:00 PM
              </li>
              <li className="text-white/55">
                Call your nearest store above for enquiries.
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} KST Spice Corner. All rights reserved.</p>
          <p>Authentic Indian & Sri Lankan Groceries · Sydney, NSW</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
